import axios from 'axios';
import { AuthResponse } from '../types/auth';
import { getApiBaseUrl } from './config';

const API_BASE_URL = getApiBaseUrl();

const authAxios = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

export const authAPI = {
  loginWithEntra: async (idToken: string): Promise<AuthResponse> => {
    try {
      const response = await authAxios.post('/auth/entra', { idToken });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const data = error.response?.data;
        if (typeof data === 'string' && data.trim()) {
          throw new Error(data);
        }
        if (data && typeof data === 'object') {
          const problem = data as { detail?: string; message?: string; title?: string };
          throw new Error(problem.detail || problem.message || problem.title || 'Microsoft Entra sign-in failed');
        }
      }

      throw error;
    }
  },
};
